module.exports = "/static/img/placeholder4.jpg?059b58991b097ccc8255b922d8ea31e2";